// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
//     apiBase: 'http://localhost:9001',
        //  apiBase: 'http://192.168.0.152:8080',
   apiBase: 'https://uttamappa.co.in:8443/pratha-admin-test',
  baseUrlImage:'https://uttamappa.co.in:8443/uploads/Pratha/Images',
  baseurlIcon:'https://uttamappa.co.in:8443/pratha-admin-test',
  env: 'dev'
};

/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
